export const isPrintMode = () => {
  return typeof window !== 'undefined' ? window.matchMedia('print').matches : null
}
